export const GET_ALL_SUBSCRIBERS = 'GET_ALL_SUBSCRIBERS';
export const CREATE_SUBSCRIBER = 'CREATE_SUBSCRIBER';